import script from "./SlideAnimationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideAnimationPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlideAnimationPanel.vue?vue&type=style&index=0&id=577ae912&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577ae912"]])

export default __exports__